export * from './IconItalic';
